import {
  GET_SELLERS,
  CREATE_SELLERS,
  DELETE_SELLERS,
  UPDATE_SELLERS,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
} from "./actionType";

// common success
export const SellersApiResponseSuccess = (actionType, data) => ({
  type: API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const SellersApiResponseError = (actionType, error) => ({
  type: API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const Sellers = (id) => ({
  type: GET_SELLERS,
  payload: { id },
});

export const CreateSellers = (data) => ({
  type: CREATE_SELLERS,
  payload: { data },
});

export const UpdateSellers = (id, data) => ({
  type: UPDATE_SELLERS,
  payload: { id, data },
});

export const DeleteSellers = (id) => ({
  type: DELETE_SELLERS,
  payload: { id },
});
